/**
 * Collection Shortcode Slider
 * Handles slider functionality for embedded collections
 */

document.addEventListener('DOMContentLoaded', function() {
  initializeSliders();
});

function initializeSliders() {
  const sliders = document.querySelectorAll('.embedded-collection--slider');
  
  sliders.forEach(function(container) {
    const slider = container.querySelector('.embedded-collection__slider');
    if (!slider) return;
    
    const wrapper = slider.querySelector('.swiper-wrapper');
    const slides = Array.from(slider.querySelectorAll('.swiper-slide'));
    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');
    const pagination = container.querySelector('.swiper-pagination');
    
    if (!wrapper || slides.length === 0) return;
    
    let currentIndex = 0;
    let slideWidth = 0;
    let visibleSlides = 0;
    let maxIndex = 0;
    
    function calculateDimensions() {
      const containerWidth = slider.offsetWidth;
      slideWidth = slides[0].offsetWidth;
      visibleSlides = Math.floor(containerWidth / slideWidth);
      maxIndex = Math.max(0, slides.length - visibleSlides);
      
      // Ensure current index is valid after resize
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
    }
    
    function createPagination() {
      if (!pagination || slides.length <= visibleSlides) return;
      
      pagination.innerHTML = '';
      
      const bulletCount = maxIndex + 1;
      for (let i = 0; i < bulletCount; i++) {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        if (i === currentIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
        }
        bullet.addEventListener('click', () => goToSlide(i));
        pagination.appendChild(bullet);
      }
    }
    
    function updateSlider() {
      const offset = currentIndex * slideWidth;
      wrapper.style.transform = `translateX(-${offset}px)`;
      
      // Update pagination
      const bullets = pagination?.querySelectorAll('.swiper-pagination-bullet');
      if (bullets) {
        bullets.forEach((bullet, index) => {
          bullet.classList.toggle('swiper-pagination-bullet-active', index === currentIndex);
        });
      }
      
      // Update button states
      if (prevBtn) {
        if (currentIndex === 0) {
          prevBtn.style.opacity = '0.3';
          prevBtn.style.pointerEvents = 'none';
          prevBtn.setAttribute('disabled', 'disabled');
        } else {
          prevBtn.style.opacity = '1';
          prevBtn.style.pointerEvents = 'auto';
          prevBtn.removeAttribute('disabled');
        }
      }
      
      if (nextBtn) {
        if (currentIndex >= maxIndex) {
          nextBtn.style.opacity = '0.3';
          nextBtn.style.pointerEvents = 'none';
          nextBtn.setAttribute('disabled', 'disabled');
        } else {
          nextBtn.style.opacity = '1';
          nextBtn.style.pointerEvents = 'auto';
          nextBtn.removeAttribute('disabled');
        }
      }
    }
    
    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateSlider();
    }
    
    function next() {
      if (currentIndex < maxIndex) {
        goToSlide(currentIndex + 1);
      }
    }
    
    function prev() {
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      }
    }
    
    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', prev);
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', next);
    }
    
    // Keyboard navigation
    container.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        next();
      }
    });
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    slider.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    slider.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          next();
        } else {
          prev();
        }
      }
    }
    
    // Resize handler with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        calculateDimensions();
        createPagination();
        updateSlider();
      }, 250);
    });
    
    // Initialize
    calculateDimensions();
    createPagination();
    updateSlider();
    
    // Make slider focusable for keyboard navigation
    container.setAttribute('tabindex', '0');
  });
}

// Re-initialize if new content is loaded dynamically
if (typeof Shopify !== 'undefined' && Shopify.theme) {
  document.addEventListener('shopify:section:load', function() {
    initializeSliders();
  });
}
